import Affix from '../../../src/components/Affix'
import Anchor from '../../../src/components/Anchor'
import AutoComplete from '../../../src/components/AutoComplete'
import Badge from '../../../src/components/Badge'
import Button from '../../../src/components/Button'
import ButtonGroup from '../../../src/components/ButtonGroup'
import Card from '../../../src/components/Card'
import Checkbox from '../../../src/components/Checkbox'
import Layout from '../../../src/components/Layout'
import Row from '../../../src/components/Row'
import Col from '../../../src/components/Col'
import Con from '../../../src/components/_Con'
import Collapse from '../../../src/components/Collapse'
import Cascader from '../../../src/components/Cascader'
import Carousel from '../../../src/components/Carousel'
import CarouselFigure from '../../../src/components/Carousel'
import Dropdown from '../../../src/components/Dropdown'
import DatePicker from '../../../src/components/DatePicker'
import Dnd from '../../../src/components/Dnd'
import Form from '../../../src/components/Form'
import BeeCheckbox from '../../../src/components/BeeCheckbox'
import BeeRadio from '../../../src/components/BeeRadio'
import BeeLoading from '../../../src/components/BeeLoading'
import BeeCollapse from '../../../src/components/BeeCollapse'
import BeeButton from '../../../src/components/BeeButton'
import BeeTabs from '../../../src/components/BeeTabs'
import BeeModal from '../../../src/components/BeeModal'
import BeeIcon from '../../../src/components/BeeIcon'
import BeePopconfirm from '../../../src/components/BeePopconfirm'
import FormControl from '../../../src/components/FormControl'
import Input from '../../../src/components/Input'
import InputNumber from '../../../src/components/InputNumber'
import Icon from '../../../src/components/Icon'
import Loading from '../../../src/components/Loading'
import Menu from '../../../src/components/Menu'
import Message from '../../../src/components/Message'
import message from '../../../src/components/Message'
import Modal from '../../../src/components/Modal'
import Notification from '../../../src/components/Notification'
import notification from '../../../src/components/Notification'
import Panel from '../../../src/components/Panel'
import Popover from '../../../src/components/Popover'
import Progress from '../../../src/components/Progress'
import ProgressBar from '../../../src/components/ProgressBar'
import Popconfirm from '../../../src/components/Popconfirm'
import Pagination from '../../../src/components/Pagination'
import Radio from '../../../src/components/Radio'
import Switch from '../../../src/components/Switch'
import Select from '../../../src/components/Select'
import Steps from '../../../src/components/Steps'
import Slider from '../../../src/components/Slider'
import Tabs from '../../../src/components/Tabs'
import Tag from '../../../src/components/Tag'
import TimePicker from '../../../src/components/TimePicker'
import Timeline from '../../../src/components/Timeline'
import Tree from '../../../src/components/Tree'
import TreeSelect from '../../../src/components/TreeSelect'
import Upload from '../../../src/components/Upload'
import Tooltip from '../../../src/components/Tooltip'
import MobileLocale from '../../../src/components/MobileLocale'
import Tile from '../../../src/components/Tile'
import SearchPanel from '../../../src/components/SearchPanel'
import Label from '../../../src/components/Label'
import Navbar from '../../../src/components/Navbar'
import Backtop from '../../../src/components/Backtop'
import Alert from '../../../src/components/Alert'
import InputGroup from '../../../src/components/InputGroup'
import FormGroup from '../../../src/components/FormGroup'
import Table from '../../../src/components/Table'
import Rate from '../../../src/components/Rate'
import ColorPicker from '../../../src/components/ColorPicker'
import LoadingState from '../../../src/components/LoadingState'
import Viewer from '../../../src/components/Viewer'
import Breadcrumb from '../../../src/components/Breadcrumb'
import PageLayout from '../../../src/components/PageLayout'
import Clipboard from '../../../src/components/Clipboard'
import Drawer from '../../../src/components/Drawer'
import Locale from '../../../src/components/Locale'
import BeeLocale from '../../../src/components/Locale'
import './index.less';
const __Library = {Affix:Affix,Anchor:Anchor,AutoComplete:AutoComplete,Badge:Badge,Button:Button,ButtonGroup:ButtonGroup,Card:Card,Checkbox:Checkbox,Layout:Layout,Row:Row,Col:Col,Con:Con,Collapse:Collapse,Cascader:Cascader,Carousel:Carousel,CarouselFigure:CarouselFigure,Dropdown:Dropdown,DatePicker:DatePicker,Dnd:Dnd,Form:Form,BeeCheckbox:BeeCheckbox,BeeRadio:BeeRadio,BeeLoading:BeeLoading,BeeCollapse:BeeCollapse,BeeButton:BeeButton,BeeTabs:BeeTabs,BeeModal:BeeModal,BeeIcon:BeeIcon,BeePopconfirm:BeePopconfirm,FormControl:FormControl,Input:Input,InputNumber:InputNumber,Icon:Icon,Loading:Loading,Menu:Menu,Message:Message,message:message,Modal:Modal,Notification:Notification,notification:notification,Panel:Panel,Popover:Popover,Progress:Progress,ProgressBar:ProgressBar,Popconfirm:Popconfirm,Pagination:Pagination,Radio:Radio,Switch:Switch,Select:Select,Steps:Steps,Slider:Slider,Tabs:Tabs,Tag:Tag,TimePicker:TimePicker,Timeline:Timeline,Tree:Tree,TreeSelect:TreeSelect,Upload:Upload,Tooltip:Tooltip,MobileLocale:MobileLocale,Tile:Tile,SearchPanel:SearchPanel,Label:Label,Navbar:Navbar,Backtop:Backtop,Alert:Alert,InputGroup:InputGroup,FormGroup:FormGroup,Table:Table,Rate:Rate,ColorPicker:ColorPicker,LoadingState:LoadingState,Viewer:Viewer,Breadcrumb:Breadcrumb,PageLayout:PageLayout,Clipboard:Clipboard,Drawer:Drawer,Locale:Locale,BeeLocale:BeeLocale}

export default {...__Library, _YonUI_YS_version: '3.1.42'}